import ServiceCategoryBudgetContainer from "./ServiceCategoryBudget.container";

export default ServiceCategoryBudgetContainer;
